import React from 'react';
import { Redirect } from 'react-router-dom';

export const AnchorDashboard = () => {
    return <Redirect to="/investor/wallet" />;
};

export default AnchorDashboard;
